var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNounVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-video-4636438",
    d: "M104.005,95.371a1.814,1.814,0,0,0-.7.142L94,99.339V95.373a2,2,0,0,0-2-2H72a2,2,0,0,0-2,2v20a2,2,0,0,0,2,2H92a2,2,0,0,0,2-2v-3.966l9.3,3.826a1.853,1.853,0,0,0,.7.142,2.1,2.1,0,0,0,2-2.2V97.571a2.1,2.1,0,0,0-2-2.2Zm-14,17a1,1,0,0,1-1,1H75a1,1,0,0,1-1-1v-14a1,1,0,0,1,1-1H89a1,1,0,0,1,1,1Zm12-2-8-3.292v-3.416l8-3.292Z",
    transform: "translate(-70.003 -93.373)",
    opacity: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounVideo);
export default __webpack_public_path__ + "static/media/noun_video.322d699a56dfb3286b1d6a936643790e.svg";
export { ForwardRef as ReactComponent };